module.exports = __webpack_public_path__ + "static/media/singapore_logo.2aed6992.svg";